import { render, staticRenderFns } from "./CardAddress.vue?vue&type=template&id=81a29b92&"
import script from "./CardAddress.vue?vue&type=script&lang=js&"
export * from "./CardAddress.vue?vue&type=script&lang=js&"
import style0 from "./CardAddress.vue?vue&type=style&index=0&id=81a29b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports